import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Users, Clock, AlertCircle, Pause } from 'lucide-react';
import { format } from 'date-fns';
import { api } from '../api/client';
import { Avatar } from '../components/ui/Avatar';
import { Badge } from '../components/ui/Badge';
import { ETAPA_MAP } from '../lib/constants';
import { parseDate } from '../lib/dates';

export function EquipePage() {
  const nav = useNavigate();
  const [grupos, setGrupos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get('/demandas/_tarefas/equipe').then((r) => setGrupos(r.equipe)).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="loader-full"><span className="spinner" /></div>;

  return (
    <div className="page">
      <div className="page-header">
        <div>
          <h1 className="page-title"><Users size={22} style={{ verticalAlign: 'middle' }} /> Equipe em ação</h1>
          <p className="page-subtitle">Quem está fazendo o quê agora</p>
        </div>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: 14 }}>
        {grupos.map((g) => (
          <div key={String(g.responsavel_id)} className="card">
            <div className="card-header" style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <Avatar nome={g.responsavel_nome} src={g.responsavel_foto} size="lg" />
              <div>
                <strong>{g.responsavel_nome}</strong>
                <div className="text-xs muted">{g.tarefas.length} tarefa{g.tarefas.length === 1 ? '' : 's'}</div>
              </div>
            </div>
            <div className="card-body" style={{ padding: 0 }}>
              {g.tarefas.length === 0 ? (
                <div className="empty" style={{ padding: 20 }}>Sem tarefas pendentes.</div>
              ) : (
                <div>
                  {g.tarefas.map((t) => (
                    <button
                      key={t.id}
                      onClick={() => nav(`/demandas/${t.demanda_codigo}`)}
                      style={{
                        display: 'block', width: '100%', textAlign: 'left', padding: 12,
                        borderTop: '1px solid var(--c-border)', background: 'white', border: 'none',
                        borderBottom: 0, cursor: 'pointer',
                      }}
                    >
                      <div style={{ fontWeight: 500, fontSize: 13 }}>{t.titulo}</div>
                      <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginTop: 4, alignItems: 'center' }}>
                        {t.status === 'em_andamento' && <Badge color="info"><AlertCircle size={10} /> em andamento</Badge>}
                        {t.status === 'bloqueada' && <Badge color="danger"><Pause size={10} /> bloqueada</Badge>}
                        <Badge color={ETAPA_MAP[t.demanda_etapa]?.color}>{ETAPA_MAP[t.demanda_etapa]?.label}</Badge>
                        {t.prazo && <span style={{ fontSize: 11, color: 'var(--c-warning)' }}>⏰ {format(parseDate(t.prazo), 'dd/MM')}</span>}
                      </div>
                      <div className="text-xs muted" style={{ marginTop: 4 }}>{t.demanda_titulo} · {t.secretaria_nome}</div>
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
